import _ from 'lodash'
import toastr from 'toastr'


import { useTranslation } from '@/shared/hooks/useTranslation'
import { showErrorAlert } from '@/shared/lib/errors'
import { Overlay } from '@/shared/ui/Overlay'

import { useAuthContext } from '../model/auth-context'
import { ConfirmationFields } from './fields/ConfirmationFields'

export const ConfirmationForm = ({ onConfirm, onError }) => {
  const {
    isLoading,
    setIsLoading,
    httpClient,
    callbackUrl,
    currentEmail,
    goToSignIn,
    handleSignIn,
    currentPassword
  } = useAuthContext()

  const { t, lang } = useTranslation()

  const handleConfirm = async () => {
    if (typeof onConfirm !== 'undefined' && _.isFunction(onConfirm)) {
      onConfirm({ email: currentEmail })
      return
    }

    toastr.success(
      t(
        'auth.accountSuccessfullyConfirmed',
        {},
        { fallback: 'Conta confirmada com sucesso' }
      )
    )

    const { ok } = await handleSignIn({
      login: currentEmail,
      password: currentPassword
    })

    if (!ok) {
      goToSignIn()
      return
    }

    try {
      // `URL.parse` é recente e não existe na lib de tipos deste projeto; o
      // `new URL` dentro do try faz o mesmo, e a falha já cai no catch.
      const objUrl = new URL(callbackUrl)
      let locatedCallbackUrl = callbackUrl
      if (objUrl) {
        if (lang && !objUrl.pathname) {
          locatedCallbackUrl = `${objUrl.origin}/${lang}`
        }
      } else if (lang) {
        locatedCallbackUrl = `/${lang}${callbackUrl}`
      }

      location.replace(locatedCallbackUrl)
    } catch (error) {
      location.replace(callbackUrl)
    }
  }
  const handleValidateToken = async token => {
    if (isLoading || !token || token.length < 6) return

    setIsLoading(true)

    try {
      await httpClient.post('/auth/confirmation', {
        email: currentEmail,
        token
      })

      await handleConfirm()
    } catch (error) {
      const emailErrors = _.get(error, 'response.data.errors.email', [])
      if (emailErrors && emailErrors.includes('já foi confirmado'))
        await handleConfirm()
      else if (typeof onError !== 'undefined' && _.isFunction(onError))
        onError({ error })
      else showErrorAlert(error)
    }

    setIsLoading(false)
  }

  return (
    <Overlay
      block
      show={false}
      active={isLoading}
      opacity="50"
      layer={
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand border-t-transparent" role="status">
          <span className="sr-only">
            {t('loading', {}, { fallback: 'Carregando...' })}
          </span>
        </div>
      }
    >
      <ConfirmationFields onValidateToken={handleValidateToken} />
    </Overlay>
  )
}

